/* eslint-disable import/no-anonymous-default-export */
export default {
  addPOBtnLabel: "Add PO",
  viewProcurementOfficerHeading: "View procurement officer",
  editProcurementOfficerHeading: "Edit Procurement officer",
  addProcurementOfficerHeading: "Add Procurement officer",
  name: "Procurement officer name",
  deleteAlert: "Are you sure want to delete this procurement officer?",
  nameError: "Procurement officer name is required",
};
